import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { throwError } from 'rxjs';
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.authService.getToken();
        
        req = req.clone({
            setHeaders: {
                'Authorization': `Bearer ${authToken}`,
                'Accept-Language': $localize.locale,
                'X-Cronox-Build': environment.version
            }
        });
        
        return next.handle(req).pipe(catchError((error: HttpErrorResponse) => {
            let message = error.error.message            
            
            if (error.status === 401) {
                this.router.navigate(['/login']);
            }
            else if (error.status === 504) {
                alert($localize `Can't connect to server.`)
            }
            else {
                alert($localize `Error: ` + message)
            }
            
            return throwError(() => error);
         }))
    }
}
